export const DEBOUNCE_TIME_TO_VIEW_PRODUCTS = 1000;

export const ADDED_FROM_APP = 'Agregado desde app';
